<div class="general-editor-container">
    <div class="header-container">
        <label>{{ title }}</label>
        <smart-icon name="close" (click)="onSlideSheetClose()" class="light"></smart-icon>
    </div>
    <div class="input-container" *ngIf="isConfigureHTMLSecurity">
        <div class="tam-form-field" [ngClass]="{'has-error':name.invalid}">
            <label class="required">Name</label>
            <input [(ngModel)]="pageData.tag" class="tam-input tam-textbox" type="text" [formControl]="name">
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['invalidHTMLTag']">
                {{'general.invalid_html_tag' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['nameDuplicated']">
                {{'general.name_already_exist' | stringLiterals}}
            </div>
        </div>
    </div>
    <div class="input-container" *ngIf="isAbbreviation">
        <div class="tam-form-field" [ngClass]="{'has-error':abbr.invalid}">
            <label class="required">Abbreviation</label>
            <input [(ngModel)]="pageData.abbreviation" class="tam-input tam-textbox" type="text" [formControl]="abbr">
            <div class="tam-form-help" *ngIf="abbr.invalid && abbr.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="abbr.invalid && abbr.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
            <div class="tam-form-help" *ngIf="abbr.invalid && abbr.errors['nameDuplicated']">
                {{'general.name_already_exist' | stringLiterals}}
            </div>
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error':canonicalForm.invalid}">
            <label class="required">Canonical Form</label>
            <input [(ngModel)]="pageData.canonicalForm" class="tam-input tam-textbox" type="text"
                [formControl]="canonicalForm">
            <div class="tam-form-help" *ngIf="canonicalForm.invalid && canonicalForm.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="canonicalForm.invalid && canonicalForm.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
        </div>
    </div>
    <div class="input-container" *ngIf="isFMROverride">
        <div class="tam-form-field" [ngClass]="{'has-error':fmrOverride.invalid}">
            <label class="required">FMROverride</label>
            <input [(ngModel)]="pageData.name" class="tam-input tam-textbox" type="text" [formControl]="fmrOverride">
            <div class="tam-form-help" *ngIf="fmrOverride.invalid && fmrOverride.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="fmrOverride.invalid && fmrOverride.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
            <div class="tam-form-help" *ngIf="fmrOverride.invalid && fmrOverride.errors['nameDuplicated']">
                {{'general.name_already_exist' | stringLiterals}}
            </div>
        </div>
        <div class="tam-form-field">
            <label>Full Match Required</label>
            <kendo-switch onLabel="On" offLabel="Off" [(ngModel)]="pageData.FMR">
            </kendo-switch>
        </div>
    </div>
    <div class="input-container" *ngIf="isStopList">
        <div class="tam-form-field" [ngClass]="{'has-error':ticker.invalid}">
            <label class="required">Ticker</label>
            <input [(ngModel)]="pageData.ticker" class="tam-input tam-textbox" type="text" [formControl]="ticker">
            <div class="tam-form-help" *ngIf="ticker.invalid && ticker.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="ticker.invalid && ticker.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
            <div class="tam-form-help" *ngIf="ticker.invalid && ticker.errors['nameDuplicated']">
                {{'general.name_already_exist' | stringLiterals}}
            </div>
        </div>
    </div>
    <div class="button-container">
        <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class="button" (click)="onSubmitClick()">
            {{'general.submit' | stringLiterals}}
        </button>
        <button tam-button [tamType]="'tertiary'" [tamSize]="'normal'" class="button" (click)="onSlideSheetClose()">
            {{'general.cancel' | stringLiterals}}
        </button>
    </div>
</div>